import { SearchOperationDto } from '../model/users-model';

export class SearchStore {
  private searchCriteria: SearchOperationDto;
  constructor() {}

  public setSearchCriteria(criteria: SearchOperationDto): void {
    this.searchCriteria = criteria;
  }

  public getSearchCriteria(): SearchOperationDto {
    return this.searchCriteria;
  }
}
